import {GuestCategory} from 'crqlar-react-common/dist/models/profile/guestCategory.model';
import {GuestCategoryService} from 'crqlar-react-common/dist/services/profile/guestCategory.service';
import {useOrganization} from 'crqlar-react-common/dist/state/auth.reducer';
import {useQuery} from 'react-query';

export const GUEST_CATEGORIES_QUERY_KEY = 'guestCategories';
const EMPTY_CATEGORIES: GuestCategory[] = [];

export const useGuestCategories = () => {
    const organization = useOrganization();
    const query = useQuery(
        [GUEST_CATEGORIES_QUERY_KEY, organization?.id],
        () => GuestCategoryService.list(),
        {enabled: !!organization?.id, staleTime: 30_000},
    );
    return {...query, categories: query.data ?? EMPTY_CATEGORIES};
};
